export const firebaseConfig = {
    apiKey: "AIzaSyBo78rydMmBbxeN_ax1ZyHRZnKtMKjzOro",
    authDomain: "realmofrich.com",
    databaseURL: "https://realmofrich-8e204-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "realmofrich-8e204",
    storageBucket: "realmofrich-8e204.appspot.com",
    messagingSenderId: "152691507915",
    appId: "1:152691507915:web:c14a0399864cfd8d3c914e",
    measurementId: "G-MWTXY3B46Z"
  };